import {Navbar} from '@common/ui/navigation/navbar/navbar';
import {SearchAutocomplete} from '@app/search/search-autocomplete';
import clsx from 'clsx';
import {IconButton} from '@ui/buttons/icon-button';
import {SearchIcon} from '@ui/icons/material/Search';
import {Link} from 'react-router';
import {Trans} from '@ui/i18n/trans';
import {Tooltip} from '@ui/tooltip/tooltip';
import {AlbanianTheatreLogo} from '@app/albanian-theatre-logo';

interface Props {
  position?: 'fixed' | 'relative';
}
export function MainNavbar({position = 'relative'}: Props) {
  return (
    <Navbar
      size="md"
      menuPosition="primary"
      // CUSTOM(albaniantheatre): "main-navbar" is the hook resources/client/app.css
      // uses to enlarge the primary menu links (Plays / People); wrapInContainer
      // keeps the header content in the same centred container as the page body
      className={clsx(position, 'main-navbar z-40 w-full flex-shrink-0')}
      border="border-none"
      alwaysDarkMode
      wrapInContainer
      // CUSTOM(albaniantheatre): CSS logo instead of image logo
      hideLogo
    >
      <AlbanianTheatreLogo className="mr-4 md:mr-24" />
      <Tooltip label={<Trans message="Search" />}>
        <IconButton elementType={Link} to="/search" className="md:hidden">
          <SearchIcon />
        </IconButton>
      </Tooltip>
      <SearchAutocomplete className="max-md:hidden" />
    </Navbar>
  );
}
